<template>
<div class="chapter">
<div class="inner_page">
<section epub:type="frontmatter" title="Dedication">
<p class="Ded1"><span class="right_1" epub:type="pagebreak" id="page_v" title="v"><span class="right_1" epub:type="pagebreak" id="page_vi" title="vi"><i>For the “divine Ms. B”<br/>Barbara C. Hodgdon<br/>(1932–2018)<br/>encore une fois</i></span></span></p>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 00a_fm0d.vue?1c7c10fa